<template lang="pug">
    #mapa-leaflet(:style='{ height: height }', style='position: relative')
        div(:id='idMapa', :style='{ height: height }')
        DrawerMenuCamadas(
            :show='ativarMenuCamadas',
            :menuMaior='menuMaior',
            :mapa='mapa || {}',
            :showStatesLayers='showStatesLayers',
            :limparMenuCamadasAtivo='limparMenuCamadasAtivo',
            @closeDrawerMenuCamadas='toggleMenuCamadas',
            @resetarLimparMenuCamadasAtivo='limparMenuCamadasAtivo = false',
            @atualizarListaCamadasModalInspecionar='atualizarListaCamadasModalInspecionar'
        )
        DrawerMenuArea(
            :show='ativarMenuArea',
            :menuMaior='menuMaior',
            :mapConfigControls='mapConfig.controls',
            :limparMenuAreaAtivo='limparMenuAreaAtivo',
            @rulerActivate='rulerActivate',
            @drawControlCalc='drawControlCalc',
            @closeDrawerMenuArea='toggleMenuArea',
            @resetarLimparMenuAreaAtivo='limparMenuAreaAtivo = false'
        )
        FerramentasSentinelHub(
            :show='ativarFerramentasSentinelHub',
            :menuMaior='menuMaior',
            :mapConfigControls='mapConfig.controls',
            :mapa='mapa'
            @closeFerramentasSentinelHub='toggleFerramentasSentinelHub',
            @resetarLimparMenuFerramentasAtivo='limparMenuFerramentasAtivo = false'
        )
        DrawerInspecionarCamadas(
            :show='mostrarDrawerInspecionar',
            :geometria='geometriaAcao',
            :camadas='camadasInspecao',
            :menuMaior='menuMaior',
            @fechar='fecharDrawerInspecionar'
        )
        .drawer-historico-agricola(v-if='mostrarDrawerHistoricoAgricola && mapa')
            DrawerHistoricoAgricola(
                :show='mostrarDrawerHistoricoAgricola',
                :geometria='geometriaAcao',
                :featureGroup='featureGroup',
                :mapa='mapa',
                @drawerHistoricoAgricolaFechar='drawerHistoricoAgricolaFechar'
            )
        .selecionar-camadas
            ModalSelecionarCamadas(
                :show='mostrarModalSelecionarCamadas',
                :camadasInspecao='camadasInspecao',
                @fechar='mostrarModalSelecionarCamadas = false',
                @inspecionar='inspecionar'
            )
        .enviar-diagnostico
            ModalEnviarGeometriaDiagnostico(
                :show='mostrarModalEnviarGeometriaDiagnostico',
                :geometria='geometriaAcao',
                @fechar='mostrarModalEnviarGeometriaDiagnostico = false'
            )
</template>

<script>
import L from 'leaflet';
import 'leaflet-easybutton';
import 'leaflet/dist/leaflet.css';
import 'leaflet-easybutton/src/easy-button.css';
import 'leaflet-fullscreen/dist/leaflet.fullscreen.css';
import 'leaflet-fullscreen/dist/Leaflet.fullscreen';
import '@/utils/mapa/leaflet-zoominfo/L.Control.Zoominfo.js';
import '@/utils/mapa/leaflet-zoominfo/L.Control.Zoominfo.css';
import 'leaflet-draw';
import '@/utils/mapa/leaflet-ruler/leaflet-ruler.js';
import '@/utils/mapa/leaflet-ruler/leaflet-ruler.css';
import 'leaflet-contextmenu';
import 'leaflet-contextmenu/dist/leaflet.contextmenu.css';
import OptionsRuler from '@/constants/OptionsRuler';
import DrawCalc from '@/constants/DrawCalc';
import geometryUtils from '@/utils/mapa/geometry.js';

import { DEFAULT_CONFIG, TILE_LAYER_CONFIG } from '@/utils/mapa/mapa.config';

import { getEstiloGeometria } from '@/utils/mapa/mapa.estilos';

import i18n from '@/main';

import { mapActions, mapState } from 'vuex';

import { sortBy } from 'lodash';

import DrawerMenuCamadas from '@/components/DrawerMenuCamadas';
import DrawerMenuArea from '@/components/DrawerMenuArea';
import FerramentasSentinelHub from '@/components/sentinelHub/FerramentasSentinelHub';
import DrawerInspecionarCamadas from '@/components/DrawerInspecionarCamadas';
import DrawerHistoricoAgricola from '@/components/DrawerHistoricoAgricola';
import ModalSelecionarCamadas from '@/components/ModalSelecionarCamadas';
import ModalEnviarGeometriaDiagnostico from '@/components/ModalEnviarGeometriaDiagnostico';

import UtilsService from '@/services/UtilsService';

export default {
    name: 'MapaGlebaCar',

    components: {
        DrawerMenuCamadas,
        DrawerMenuArea,
        FerramentasSentinelHub,
        DrawerInspecionarCamadas,
        DrawerHistoricoAgricola,
        ModalSelecionarCamadas,
        ModalEnviarGeometriaDiagnostico
    },

    props: {
        height: {
            required: false,
            type: String,
            default: '100%'
        },

        mapConfig: {
            required: false,
            type: Object,
            default: () => ({})
        },

        idMapa: {
            required: true,
            type: String
        },

        territorioGeometria: {
            type: Object,
            default: () => []
        },

        showStatesLayers: {
            type: Boolean,
            required: false,
            default: true
        },

        menuMaior: {
            type: Boolean,
            required: false,
            default: false
        }
    },

    data() {
        return {
            mapa: null,
            config: {},
            featureGroup: L.featureGroup(),
            mapLayers: null,
            camadas: [],
            desabilitaZoom: false,
            fullscreenAtivado: false,
            selectorIdMapa: '',
            ufsLayer: null,
            municipioLayer: null,
            carLayer: null,
            carMarkers: null,
            estadoSelecionado: null,
            corEstadoSelecionado: null,
            municipioSelecionado: null,
            corMunicipioSelecionado: null,
            contornoMunicipioSelecionado: null,
            mudancaAgrupamento: null,
            municipioNome: null,
            drawPolygonCalc: null,
            ativarMenuCamadas: false,
            limparMenuCamadasAtivo: false,
            ativarFerramentasSentinelHub: false,
            ativarMenuArea: false,
            limparMenuAreaAtivo: false,
            geometriaAcao: {},
            mostrarModalEnviarGeometriaDiagnostico: false,
            mostrarModalSelecionarCamadas: false,
            mostrarDrawerInspecionar: false,
            mostrarDrawerHistoricoAgricola: false,
            camadasInspecao: [],
            pinIcon: null,
            pesquisaExterna: false
        };
    },

    computed: {
        ...mapState(['usuarioLogado', 'glebaVisualizada'])
    },

    async mounted() {
        const vm = this;
        this.selectorIdMapa = `#${this.idMapa}`;
        vm.config = Object.assign(DEFAULT_CONFIG);

        if (!vm.mapa) {
            await vm.createMap();
        }
        setTimeout(async () => {
            if (!vm.mapa) {
                await vm.createMap();
            }
        }, 4500);

        setTimeout(() => {
            vm.addEscListener();
            vm.handleFullscreenClick();
            vm.handleClickOutsideMenus();
        }, 1000);
    },

    watch: {
        territorioGeometria: function () {
            this.mostrarCar();
        },

        mapConfig: function () {
            this.addMapControls();
        },

        glebaVisualizada: {
            deep: true,
            handler(value) {
                if (this.mapLayers) {
                    this.mapLayers.clearLayers();
                }
                this.mostrarGleba(value);
            }
        },

        mostrarDrawerInspecionar(val) {
            if (val) {
                this.changeMapInteractiveDrawers(true);
            } else {
                this.changeMapInteractiveDrawers(false);
            }
        },

        ativarMenuCamadas(val) {
            if (val) {
                this.changeMapInteractiveDrawers(true);
            } else {
                this.changeMapInteractiveDrawers(false);
            }
        },

        ativarMenuArea(val) {
            if (val) {
                this.changeMapInteractiveDrawers(true);
            } else {
                this.changeMapInteractiveDrawers(false);
            }
        },

        ativarFerramentasSentinelHub(val) {
            if (val) {
                this.changeMapInteractiveDrawers(true);
            } else {
                this.changeMapInteractiveDrawers(false);
            }
        }
    },
    methods: {
        ...mapActions(['setGeometriaDesenhadaAcao', 'setAcaoEscolhida']),
        async createMap() {
            L.drawLocal = {
                draw: {
                    handlers: {
                        polygon: {
                            tooltip: {
                                start: i18n?.t(
                                    'mensagens.menuMapa.cliqueParaDesenharPoligono'
                                ),
                                cont: i18n?.t(
                                    'mensagens.menuMapa.cliqueParaContinuarDesenhando'
                                ),
                                end: i18n?.t(
                                    'mensagens.menuMapa.cliquePrimeiroPontoParaTerminar'
                                )
                            }
                        },
                        polyline: {
                            error: i18n?.t(
                                'mensagens.menuMapa.erro.arestasNaoPodemCruzar'
                            ),
                            tooltip: {
                                start: i18n?.t(
                                    'mensagens.menuMapa.clique.desenharLinha'
                                ),
                                cont: i18n?.t(
                                    'mensagens.menuMapa.clique.continuarDesenhando'
                                ),
                                end: i18n?.t(
                                    'mensagens.menuMapa.clique.paraTerminar'
                                )
                            }
                        },
                        marker: {
                            tooltip: {
                                start: i18n?.t(
                                    'mensagens.menuMapa.clique.inserirMarcador'
                                ),
                                cont: i18n?.t(
                                    'mensagens.menuMapa.clique.continuarDesenhando'
                                ),
                                end: i18n?.t(
                                    'mensagens.menuMapa.clique.paraTerminar'
                                )
                            }
                        }
                    }
                }
            };
            
            L.Map.include({
                _initControlPos: function () {
                    const corners = (this._controlCorners = {});
                    const container = (this._controlContainer =
                        L.DomUtil.create('div', 'leaflet-control-container', this._container));

                    function createCorner(vSide, hSide) {
                        const className = `leaflet-${vSide} leaflet-${hSide}`;

                        corners[vSide + hSide] = L.DomUtil.create('div', className, container);
                    }

                    L.DomEvent.disableClickPropagation(container);
                    L.DomEvent.disableScrollPropagation(container);

                    createCorner('top', 'left');
                    createCorner('top', 'right');
                    createCorner('bottom', 'left');
                    createCorner('bottom', 'right');
                    createCorner('top', 'center');
                    createCorner('middle', 'center');
                    createCorner('middle', 'left');
                    createCorner('middle', 'right');
                    createCorner('bottom', 'center');
                }
            });

            this.mapa = L.map(this.idMapa, {
                ...this.config,
                contextmenu: this.mapConfig.inspecionar,
                contextmenuItems: [
                    {
                        text: this.$t(`mensagens.comuns.inspecionar`),
                        callback: this.selecionarCamadas
                    }
                ],
                maxZoom: 17
            });

            L.tileLayer(TILE_LAYER_CONFIG.url, {
                attribution: TILE_LAYER_CONFIG.attribution
            }).addTo(this.mapa);

            this.addMapControls();

            this.featureGroup.addTo(this.mapa);

            this.mapa.on(L.Draw.Event.CREATED, e => {
                let layer = e.layer;
                layer.layerType = e.layerType;
                this.showPopupAcoes(layer);
            });
        },

        mostrarCar() {
            const geometriaLayer = L.geoJSON(this.territorioGeometria);
            geometriaLayer.setStyle({color: 'yellow', fillColor: 'transparent'});
            geometriaLayer.addTo(this.mapa);
            this.mapa.fitBounds(geometriaLayer.getBounds());
        },

        clearLayers(feature) {
            if (feature) {
                this.mapa.removeLayer(feature);
                feature = null;
            }
        },

        changeMapInteractiveDrawers(lockInteractive) {
            let lockFunc = 'enable';
            if (lockInteractive) {
                lockFunc = 'disable';
            }

            this.mapa.dragging[lockFunc]();
            this.mapa.touchZoom[lockFunc]();
            this.mapa.doubleClickZoom[lockFunc]();
            this.mapa.scrollWheelZoom[lockFunc]();
            this.mapa.boxZoom[lockFunc]();
            this.mapa.keyboard[lockFunc]();

            if (this.mapa.tap) this.mapa.tap[lockFunc]();
        },

        acaoClick(dadosImovel) {
            let getIdMunicipio = dadosImovel.codigo.split('-');
            this.$router.push({
                name: 'InteligenciaTerritorialImovel',
                params: {
                    uf: dadosImovel.siglaEstado,
                    codMunicipioIbge: getIdMunicipio[1],
                    car: dadosImovel.codigo
                }
            });
        },

        zoomToFeature(e) {
            if (this.pesquisaExterna === true) {
                this.mapa.fitBounds(e.getBounds());
            } else {
                const layer = e.target;
                this.mapa.fitBounds(layer.getBounds());
            }
        },

        getColor(d) {
            return d === 1 ? '#FFFF00' : '#FFFFF';
        },

        mostrarGleba(gleba) {
            const glebaLayer = L.geoJSON(gleba);
            glebaLayer.setStyle(getEstiloGeometria('car'));
            glebaLayer.addTo(this.mapa);
            this.mapLayers = glebaLayer;
        },

        addEscListener() {
            const vm = this;
            $(document).bind('fullscreenchange webkitfullscreenchange mozfullscreenchange msfullscreenchange', function (e) {
                var fullscreenElement = document.fullscreenElement || document.webkitFullscreenElement || document.mozFullscreenElement || document.msFullscreenElement;

                if (!fullscreenElement) {
                    vm.fullscreenAtivado = !vm.fullscreenAtivado;
                    let idMapaLeaflet = '#mapa-leaflet';

                    if (vm.ativarMenuArea && vm.fullscreenAtivado) {
                        if (vm.doubleMapOnPage) {
                            $(vm.selectorIdMapa).prepend(
                                document.querySelectorAll(
                                    '#drawer-menu-area'
                                )[1]
                            );
                        } else {
                            $(vm.selectorIdMapa).prepend(
                                $('#drawer-menu-area')
                            );
                        }
                    } else if (vm.ativarMenuArea && !vm.fullscreenAtivado) {
                        if (!vm.doubleMapOnPage) {
                            $(idMapaLeaflet).prepend(
                                $('#drawer-menu-area')
                            );
                        }
                    }

                    if (vm.ativarMenuCamadas && vm.fullscreenAtivado) {
                        if (vm.doubleMapOnPage) {
                            $(vm.selectorIdMapa).prepend(
                                document.querySelectorAll(
                                    '#drawer-menu-camadas'
                                )[1]
                            );
                        } else {
                            $(vm.selectorIdMapa).prepend(
                                $('#drawer-menu-camadas')
                            );
                        }
                    } else if (vm.ativarMenuCamadas && !vm.fullscreenAtivado) {
                        if (!vm.doubleMapOnPage) {
                            $(idMapaLeaflet).prepend(
                                $('#drawer-menu-camadas')
                            );
                        }
                    }

                    if (vm.ativarFerramentasSentinelHub && vm.fullscreenAtivado) {
                        if (vm.doubleMapOnPage) {
                            $(vm.selectorIdMapa).prepend(
                                document.querySelectorAll(
                                    '#ferramentas-sentinel'
                                )[1]
                            );
                        } else {
                            $(vm.selectorIdMapa).prepend(
                                $('#ferramentas-sentinel')
                            );
                        }
                        vm.handleSentinelInputsOnFullscreen();
                    } else if (vm.ativarFerramentasSentinelHub && !vm.fullscreenAtivado) {
                        if (!vm.doubleMapOnPage) {
                            $(idMapaLeaflet).prepend(
                                $('#ferramentas-sentinel')
                            );
                        }
                    }
                }
            });

            document.addEventListener('keyup', (e) => {
                if (e.keyCode === 27) {
                    $(
                        vm.selectorIdMapa + ' .leaflet-interactive.marker-active.marcador'
                    ).removeClass('active');
                    $(vm.selectorIdMapa + ' .leaflet-interactive.drawCalc').removeClass('active');
                    $(vm.selectorIdMapa + ' .leaflet-interactive.draw').removeClass('active');
                }
            });
        },

        addMapControls() {
            this.zoomControl();
            this.centralizeControl();

            if (this.mapConfig.controls.fullscreen) {
                this.fullscreenControl();
            }

            if (this.mapConfig.controls.camadasControl) {
                this.camadasControl();
            }

            if (this.usuarioLogado.sentinelHubAccess) {
                this.addBotaoSentinelHub();
            }

            L.control
                .coordinates({
                    position: 'bottomcenter',
                    decimals: 10,
                    decimalSeperator: '.',
                    labelTemplateLat: 'Latitude: {y}',
                    labelTemplateLng: 'Longitude: {x}'
                })
                .addTo(this.mapa);

            this.addBotaoArea();
            this.rulerControl();

            if (this.mapConfig.controls.drawControl) {
                this.drawControl();
            }
        },

        zoomControl() {
            L.control
                .zoom({
                    position: 'topright',
                    zoomControl: false
                })
                .addTo(this.mapa);
        },

        centralizeControl() {
            L.easyButton({
                id: 'botao-centralizar-zoom',
                position: 'topright',
                leafletClasses: true,
                states: [
                    {
                        stateName: 'center',
                        onClick: () => this.centralize(),
                        title: 'Centralizar',
                        icon: 'mdi mdi-crosshairs-gps'
                    }
                ]
            }).addTo(this.mapa);
        },

        refreshMap() {
            this.mapa.invalidateSize();
            this.centralize();
        },

        centralize() {
            this.mapa.setView(
                DEFAULT_CONFIG.center,
                DEFAULT_CONFIG.zoom
            );
        },

        fullscreenControl() {
            this.mapa.addControl(new L.Control.Fullscreen({position: 'topright'}));
        },

        showPopupAcoes(layer) {
            let mapa = this.mapa;
            if (layer.options.draggable !== true) {
                layer.options.draggable = true;
                this.featureGroup.addLayer(layer);
                this.$emit('draw-created', layer);
            }

            let acoes = [];

            if (this.mapConfig.inspecionar) {
                acoes.push({
                    id: 2,
                    botao: '<i class="el el-icon-search text-white"><span> Inspecionar</span></i>',
                    acao: () => {
                        this.geometriaAcao = layer.toGeoJSON().geometry;
                        this.mostrarModalSelecionarCamadas = true;
                    }
                });
            }

            if (this.mapConfig.diagnostico) {
                acoes.push({
                    id: 3,
                    botao: '<i class="flow flow-environment text-white"><span> Diagnóstico</span></i>',
                    acao: () => {
                        this.geometriaAcao = layer.toGeoJSON().geometry;
                        this.setGeometriaDesenhadaAcao(this.geometriaAcao);
                        this.setAcaoEscolhida('DIAGNOSTICO');

                        this.$router.currentRoute.name ===
                            'DiagnosticoSocioambiental'
                            ? this.$emit('diagnostico', this.geometriaAcao)
                            : (this.mostrarModalEnviarGeometriaDiagnostico = true);
                    }
                });
            }

            acoes.push({
                id: 5,
                botao: '<i class="el el-icon-delete text-white"><span> Remover</span></i>',
                acao: () => {
                    this.$emit(
                        'removerTerritorio',
                        layer.identificadorGeometria
                    );
                    mapa.removeLayer(layer);
                }
            });

            const botaoHistoricoAgricola = {
                id: 1,
                botao: '<i class="flow flow-environment text-white"><span> Histórico agrícola</span></i>',
                acao: () => {
                    this.geometriaAcao = layer.toGeoJSON().geometry;
                    this.mostrarDrawerHistoricoAgricola = true;
                    this.closePopup();
                }
            };

            const botaoDownloadKml = {
                id: 4,
                botao: '<i class="el el-icon-download text-white"><span> Baixar polígono em KML</span></i>',
                acao: () => {
                    this.geometriaAcao = layer.toGeoJSON().geometry;
                    UtilsService.baixarKMLdeGeometria(
                        layer.toGeoJSON().geometry
                    );
                    this.closePopup();
                }
            };

            if (
                this.usuarioLogado.historicoMonitoramentoAccess &&
                (this.mapConfig.historicoMonitoramento === undefined ||
                    this.mapConfig.historicoMonitoramento === true)
            ) {
                acoes.push(botaoHistoricoAgricola);
            }

            if (layer.layerType === 'polygon') {
                acoes.push(botaoDownloadKml);
            }

            acoes = sortBy(acoes, ['id']);

            const elMenu = document.createElement('div');
            elMenu.setAttribute('id', 'menu-popup-ponto');

            const areaHa = this.formatAreaHa(
                geometryUtils.calcularAreaHaFromLayer(layer)
            );
            const areaInfo = document.createElement('p');
            if (layer.toGeoJSON().geometry.type !== 'Point') {
                areaInfo.innerHTML = `Área do polígono<br>${areaHa} (ha)`;
            }

            acoes.forEach(({ id, botao, acao }) => {
                const elBtnAcao = document.createElement('a');
                elBtnAcao.classList.add('btn');
                elBtnAcao.classList.add('container-botoes-inspecionar');
                if (id !== 5) {
                    elBtnAcao.classList.add('btn');
                } else {
                    elBtnAcao.classList.add('btn-danger');
                }

                elBtnAcao.innerHTML = botao;
                elBtnAcao.href = 'javascript:void(0)';
                elBtnAcao.onclick = acao;

                elMenu.appendChild(elBtnAcao);
            });

            if (layer.layerType === 'marker') {
                const elLatLng = document.createElement('p');
                elLatLng.setAttribute('class', 'latlng-popup');
                elLatLng.innerHTML = `Latitude: ${layer._latlng.lat.toFixed(
                    4
                )} <br> Longitude: ${layer._latlng.lng.toFixed(4)}`;

                elMenu.appendChild(elLatLng);
                this.limparMenuFerramentasAtivo = true;
            }

            elMenu.appendChild(areaInfo);

            layer.bindPopup(elMenu, {
                maxWidth: 'auto'
            });

            switch (layer.layerType) {
                case 'marker':
                    $(
                        '.leaflet-interactive.marker-active.marcador'
                    ).removeClass('active');
                    break;

                case 'polygon':
                    $('.leaflet-interactive.drawCalc').removeClass('active');
                    $('.leaflet-interactive.draw').removeClass('active');
                    break;
            }
        },

        formatAreaHa(areaHa) {
            if (!areaHa) return;
            const area = String(areaHa);
            if (area.includes(',')) {
                let n = areaHa.split(',', 2);
                return n[0] + ',' + n[1].substr(2);
            }
            const options = {
                style: 'decimal',
                currency: 'BRL',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            };
            const formatNumber = new Intl.NumberFormat('pt-BR', options);
            return formatNumber.format(areaHa);
        },

        camadasControl() {
            L.easyButton({
                id: 'botao-camadas',
                position: 'topright',
                states: [
                    {
                        stateName: 'bloco-camadas',
                        onClick: this.toggleMenuCamadas,
                        title: 'Camadas',
                        icon: 'mdi mdi-layers-outline'
                    }
                ]
            }).addTo(this.mapa);
        },

        addBotaoArea() {
            L.easyButton({
                id: 'botao-area',
                position: 'topright',
                states: [
                    {
                        stateName: 'bloco-area',
                        onClick: this.toggleMenuArea,
                        title: 'Área',
                        icon: 'mdi mdi-vector-square mdi-flip-h'
                    }
                ]
            }).addTo(this.mapa);
        },

        addBotaoSentinelHub() {
            L.easyButton({
                id: 'botao-sentinel-hub',
                position: 'topright',
                states: [
                    {
                        stateName: 'bloco-sentinel-hub',
                        onClick: this.toggleFerramentasSentinelHub,
                        title: 'Imagens Sentinel 2',
                        icon: 'mdi mdi-satellite-variant'
                    }
                ]
            }).addTo(this.mapa);
        },

        drawControlCalc() {
            const polyOptionsCalc = DrawCalc.OPTIONS;

            this.drawPolygonCalc = new L.Draw.Polygon(
                this.mapa,
                polyOptionsCalc
            );

            this.drawCalc();
        },

        drawCalc() {
            this.closePopup();
            if (!this.drawPolygonCalc.enabled()) {
                this.drawPolygonCalc.enable();
                $('.leaflet-interactive.drawCalc').addClass('active');
            } else {
                this.drawPolygonCalc.disable();
                $('.leaflet-interactive.drawCalc').removeClass('active');
            }
        },

        closePopup() {
            this.mapa.eachLayer(function (layer) {
                layer.closePopup();
            });
        },

        inspecionar(camadasSelecionasModal, tipo) {
            this.camadasInspecao = camadasSelecionasModal;
            this.mostrarModalSelecionarCamadas = false;

            this.mostrarDrawerInspecionar = true;

            const pinIcon = L.icon({
                iconUrl:
                    'https://lyra-v1.s3.amazonaws.com/Map-Marker-PNG-File.png',
                iconSize: [36, 36]
            });

            if (this.geometriaAcao.coordinates.length === 2) {
                this.pinIcon = L.marker(
                    [
                        this.geometriaAcao.coordinates[1],
                        this.geometriaAcao.coordinates[0]
                    ],
                    { icon: pinIcon }
                );
                this.mapa.addLayer(this.pinIcon);
            }

            const vm = this;

            let fullscreenAtivado = document.querySelector(
                this.selectorIdMapa + ' [title="Exit Fullscreen"]'
            );

            if (fullscreenAtivado) {
                $(vm.selectorIdMapa).prepend(
                    $('#drawer-inspecionar-camadas')
                );
            }
        },

        atualizarListaCamadasModalInspecionar(camadas) {
            this.camadasInspecao = camadas.map(camada => camada.codigo);
        },

        fecharDrawerInspecionar() {
            this.mostrarDrawerInspecionar = false;
            if (this.pinIcon) {
                this.mapa.removeLayer(this.pinIcon);
            }
        },

        drawerHistoricoAgricolaFechar() {
            this.mostrarDrawerHistoricoAgricola = false;
            if (this.pinIcon) {
                this.mapa.removeLayer(this.pinIcon);
            }
        },

        rulerControl() {
            L.control.ruler(OptionsRuler.DEFAULT).addTo(this.mapa);
            $('.leaflet-bar.leaflet-ruler.leaflet-control').addClass('none');
        },

        rulerActivate() {
            setTimeout(() => {
                $(this.selectorIdMapa + ' .leaflet-bar.leaflet-ruler.leaflet-control').click();
            }, 200);
        },

        drawControl() {
            const polyOptions = {
                allowIntersection: false,
                drawError: {
                    color: '#e1e100',
                    message:
                        '<strong>As arestas do polígono não devem se cruzar</strong>'
                },
                shapeOptions: {
                    color: '#bada55',
                    showMeasurements: false
                },
                icon: new L.DivIcon({
                    iconSize: new L.Point(10, 10),
                    className:
                        'leaflet-div-icon leaflet-editing-icon leaflet-touch-icon'
                }),
                touchIcon: new L.DivIcon({
                    iconSize: new L.Point(10, 10),
                    className:
                        'leaflet-div-icon leaflet-editing-icon leaflet-touch-icon'
                })
            };

            this.drawPolygon = new L.Draw.Polygon(this.mapa, polyOptions);
            document.addEventListener(
                'keydown',
                function (event) {
                    if (event.key === 'Escape' && this.drawPolygon.enabled()) {
                        this.drawPolygon.disable();
                        $(this.selectorIdMapa + ' .leaflet-interactive.draw').removeClass('active');
                    }
                }.bind(this)
            );
            L.easyButton({
                id: 'botao-desenhar',
                position: 'topright',
                leafletClasses: true,
                states: [
                    {
                        stateName: 'center',
                        onClick: () => this.draw(),
                        title: this.$t('mensagens.menuMapa.iconesFerramentas.desenhar'),
                        icon: 'mdi mdi-pencil-outline'
                    }
                ]
            }).addTo(this.mapa);

            $(this.selectorIdMapa + ` .leaflet-interactive[title="${this.$t('mensagens.menuMapa.iconesFerramentas.desenhar')}"]`).addClass('draw');
        },

        draw() {
            if (this.mapa.doubleClickZoom.enabled()) {
                if (!this.drawPolygon.enabled()) {
                    this.drawPolygon.enable();
                    $(this.selectorIdMapa + ' .leaflet-interactive.draw').addClass('active');
                } else {
                    this.drawPolygon.disable();
                    $(this.selectorIdMapa + ' .leaflet-interactive.draw').removeClass('active');
                }
            }
        },

        toggleMenuCamadas() {
            const vm = this;

            if (this.ativarFerramentasSentinelHub) {
                this.toggleFerramentasSentinelHub();
            }

            if (this.ativarMenuArea) {
                this.toggleMenuArea();
            }

            this.ativarMenuCamadas = !this.ativarMenuCamadas;
            this.botaoMenuAtivoCamadas('#botao-camadas');
            if (this.ativarMenuCamadas) {
                let fullscreenAtivado = document.querySelector(
                    this.selectorIdMapa + ' [title="Exit Fullscreen"]'
                );

                if (fullscreenAtivado) {
                    setTimeout(() => {
                        $(vm.selectorIdMapa).prepend(
                            $('#drawer-menu-camadas')
                        );
                    }, 200);
                }

                if (this.menuMaior) {
                    document.querySelector('.leaflet-right').classList.remove('leaflet-menu-fechado');
                    document.querySelector('.leaflet-right').classList.add('leaflet-menu-aberto');
                } else {
                    document.querySelector('.leaflet-right').classList.remove('leaflet-menu-menor-fechado');
                    document.querySelector('.leaflet-right').classList.add('leaflet-menu-menor-aberto');
                }
            } else {
                if (this.menuMaior) {
                    document.querySelector('.leaflet-right').classList.remove('leaflet-menu-fechado');
                    document.querySelector('.leaflet-right').classList.add('leaflet-menu-fechado');
                } else {
                    document.querySelector('.leaflet-right').classList.remove('leaflet-menu-menor-fechado');
                    document.querySelector('.leaflet-right').classList.add('leaflet-menu-menor-fechado');
                }
            }
        },

        toggleFerramentasSentinelHub() {
            if (this.ativarMenuCamadas) {
                this.toggleMenuCamadas();
            }

            if (this.ativarMenuArea) {
                this.toggleMenuArea();
            }

            this.ativarFerramentasSentinelHub = !this.ativarFerramentasSentinelHub;
            this.botaoMenuAtivo('#botao-sentinel-hub', this.ativarFerramentasSentinelHub);
            if (this.ativarFerramentasSentinelHub) {
                let fullscreenAtivado = document.querySelector(
                    this.selectorIdMapa + ' [title="Exit Fullscreen"]'
                );

                if (fullscreenAtivado) {
                    setTimeout(() => {
                        $(this.selectorIdMapa).prepend(
                            $('#ferramentas-sentinel')
                        );
                    }, 200);
                }

                if (this.menuMaior) {
                    document.querySelector('.leaflet-right').classList.remove('leaflet-menu-fechado');
                    document.querySelector('.leaflet-right').classList.add('leaflet-menu-aberto');
                } else {
                    document.querySelector('.leaflet-right').classList.remove('leaflet-menu-menor-fechado');
                    document.querySelector('.leaflet-right').classList.add('leaflet-menu-menor-aberto');
                }
            } else {
                if (this.menuMaior) {
                    document.querySelector('.leaflet-right').classList.remove('leaflet-menu-fechado');
                    document.querySelector('.leaflet-right').classList.add('leaflet-menu-fechado');
                } else {
                    document.querySelector('.leaflet-right').classList.remove('leaflet-menu-menor-fechado');
                    document.querySelector('.leaflet-right').classList.add('leaflet-menu-menor-fechado');
                }
            }
        },

        toggleMenuArea() {
            if (this.ativarFerramentasSentinelHub) {
                this.toggleFerramentasSentinelHub();
            }
            if (this.ativarMenuCamadas) {
                this.toggleMenuCamadas();
            }

            this.ativarMenuArea = !this.ativarMenuArea;
            this.botaoMenuAtivo('#botao-area', this.ativarMenuArea);
            if (this.ativarMenuArea) {
                let fullscreenAtivado = document.querySelector(
                    this.selectorIdMapa + ' [title="Exit Fullscreen"]'
                );

                if (fullscreenAtivado) {
                    setTimeout(() => {
                        $(this.selectorIdMapa).prepend(
                            $('#drawer-menu-area')
                        );
                    }, 200);
                }

                if (this.menuMaior) {
                    document.querySelector('.leaflet-right').classList.remove('leaflet-menu-fechado');
                    document.querySelector('.leaflet-right').classList.add('leaflet-menu-aberto');
                } else {
                    document.querySelector('.leaflet-right').classList.remove('leaflet-menu-menor-fechado');
                    document.querySelector('.leaflet-right').classList.add('leaflet-menu-menor-aberto');
                }
            } else {
                if (this.menuMaior) {
                    document.querySelector('.leaflet-right').classList.remove('leaflet-menu-fechado');
                    document.querySelector('.leaflet-right').classList.add('leaflet-menu-fechado');
                } else {
                    document.querySelector('.leaflet-right').classList.remove('leaflet-menu-menor-fechado');
                    document.querySelector('.leaflet-right').classList.add('leaflet-menu-menor-fechado');
                }
            }
        },

        botaoMenuAtivo(seletor, condition) {
            if (condition) {
                document.querySelector(seletor).classList.add('active');
            } else {
                document.querySelector(seletor).classList.remove('active');
            }
        },

        botaoMenuAtivoCamadas(seletor) {
            if (this.ativarMenuCamadas) {
                document.querySelector(seletor).classList.add('active');
            } else {
                document.querySelector(seletor).classList.remove('active');
            }
        },

        handleSentinelInputsOnFullscreen() {
            let selectorIdMapa = this.selectorIdMapa;

            setTimeout(() => {
                let datePicker = document.querySelector(
                    selectorIdMapa + ' .el-date-editor'
                );
                datePicker.addEventListener('click', function () {
                    let fullscreenAtivado = document.querySelector(
                        selectorIdMapa + ' [title="Exit Fullscreen"]'
                    );
                    let ferramentasSentinelContainer = document.querySelector(selectorIdMapa + ' #ferramentas-sentinel .el-drawer.rtl');
                    ferramentasSentinelContainer.addEventListener('click', function () {
                        setTimeout(() => {
                            $(selectorIdMapa + ' .leaflet-top').removeClass(
                                'fullscreen-ativado'
                            );
                        }, 10);
                    });
                    if (fullscreenAtivado) {
                        setTimeout(() => {
                            $(
                                selectorIdMapa +
                                ' .ferramentas-sentinel'
                            ).prepend(
                                $('.el-picker-panel.el-date-range-picker')
                            );
                            $(selectorIdMapa + ' .leaflet-top').addClass(
                                'fullscreen-ativado'
                            );
                        }, 20);
                    }
                });
            }, 300);
        },

        handleFullscreenClick() {
            if (this.mapConfig.controls.fullscreen) {
                const vm = this;
                var fullScreenButton = document.querySelector('.leaflet-control-fullscreen-button');

                fullScreenButton.addEventListener('click', function () {
                    vm.fullscreenAtivado = !vm.fullscreenAtivado;
                    let idMapaLeaflet = '#mapa-leaflet';
                    setTimeout(() => {
                        if (vm.ativarMenuFerramentas && vm.fullscreenAtivado) {
                            $(vm.selectorIdMapa).prepend(
                                $('#drawer-menu-ferramentas')
                            );
                            vm.handleModalAnotacaoInputsOnFullscreen();
                        } else if (vm.ativarMenuFerramentas && !vm.fullscreenAtivado) {
                            $(idMapaLeaflet).prepend(
                                $('#drawer-menu-ferramentas')
                            );
                        }
                        if (vm.ativarMenuArea && vm.fullscreenAtivado) {
                            $(vm.selectorIdMapa).prepend(
                                $('#drawer-menu-area')
                            );
                        } else if (vm.ativarMenuArea && !vm.fullscreenAtivado) {
                            $(idMapaLeaflet).prepend(
                                $('#drawer-menu-area')
                            );
                        }
                        if (vm.ativarMenuCamadas && vm.fullscreenAtivado) {
                            $(vm.selectorIdMapa).prepend(
                                $('#drawer-menu-camadas')
                            );
                        } else if (vm.ativarMenuCamadas && !vm.fullscreenAtivado) {
                            $(idMapaLeaflet).prepend(
                                $('#drawer-menu-camadas')
                            );
                        }
                        if (vm.ativarFerramentasSentinelHub && vm.fullscreenAtivado) {
                            $(vm.selectorIdMapa).prepend(
                                $('#ferramentas-sentinel')
                            );
                            vm.handleSentinelInputsOnFullscreen();
                        } else if (vm.ativarFerramentasSentinelHub && !vm.fullscreenAtivado) {
                            $(idMapaLeaflet).prepend(
                                $('#ferramentas-sentinel')
                            );
                        }
                    }, 200);
                });
            }
        },

        handleClickOutsideMenus() {
            const vm = this;
            setTimeout(() => {
                window.onclick = function (event) {
                    var elDrawerCamadas = document.querySelector(
                        '#drawer-menu-camadas .el-drawer'
                    );
                    var elDrawerArea = document.querySelector(
                        '#drawer-menu-area .el-drawer'
                    );
                    var elDrawerSentinelHub = document.querySelector(
                        '#ferramentas-sentinel .el-drawer'
                    );

                    if (
                        event.target.contains(elDrawerCamadas) &&
                        event.target !== elDrawerCamadas
                    ) {
                        if (vm.ativarMenuCamadas) {
                            vm.toggleMenuCamadas();
                        }
                    }

                    if (
                        event.target.contains(elDrawerArea) &&
                        event.target !== elDrawerArea
                    ) {
                        if (vm.ativarMenuArea) {
                            vm.toggleMenuArea();
                        }
                    }

                    if (
                        event.target.contains(elDrawerSentinelHub) &&
                        event.target !== elDrawerSentinelHub
                    ) {
                        if (vm.ativarFerramentasSentinelHub) {
                            vm.toggleFerramentasSentinelHub();
                            setTimeout(() => {
                                $(vm.selectorIdMapa + ' .leaflet-top').removeClass(
                                    'fullscreen-ativado'
                                );
                            }, 10);
                        }
                    }
                };
            }, 200);
        }
    }
};
</script>

<style lang="scss">
.leaflet-top.leaflet-right .mdi:before,
.leaflet-top.leaflet-right .mdi-set {
    font-size: large !important;
}
</style>
